import QuestionnaireForm from 'app/features/questionnaires/components/QuestionnaireForm';
import { useSelector } from 'react-redux';
import { useValidateQuestionnaireForm } from '../../useValidateQuestionnaire';
import { fields, validationSchema } from './fields';
import { selectPension } from './slice';

export interface IPensionProps {}

const PATH = 'spouseIncome.pension';
const SELECT = selectPension;

export function useValidateSpouseIncomePension() {
  const { values } = useSelector(SELECT);

  return useValidateQuestionnaireForm(PATH, values, validationSchema);
}

export default function Pension(props: IPensionProps) {
  const initialState = useSelector(SELECT);

  return (
    <QuestionnaireForm
      defautlValues={initialState.values}
      fields={fields}
      validationSchema={validationSchema}
      className="md-max:grid md-max:grid-cols-4 md-max:gap-y-4"
      fieldClassName="md-max:col-span-4"
    />
  );
}
